<template>
  <div class="address">
    <div class="icon" @click="onClick(dataSource)">{{dataSource.userName && dataSource.userName[0]}}</div>
    <div class="detail" @click="onClick(dataSource)">
      <div class="detail-title">
        <div>{{dataSource.userName}}</div>
        <div>{{dataSource.telephone}}</div>
        <div v-if="!dataSource.defaultFlag">默认</div>
      </div>
      <div>{{dataSource.address}}</div>
      <div>{{dataSource.email}}</div>
    </div>
    <div class="operation" @click="editAddress(dataSource)">编辑</div>
  </div>
</template>

<script>
export default {
  props: {
    dataSource: {
      type: Object
    },
    editorLink: {
      type: String
    },
    onClick: {
      type: Function
    }
  },
  data: () => {
    return {

    }
  },
  mounted () {
  },
  methods: {
    editAddress (receiver) {
      this.$router.push({
        path: this.editorLink,
        query: {
          receiverId: receiver.id,
          merchantId: this.$route.query.merchantId
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .address {
    height: 170px;
    display: flex;
    background: white;
    border-bottom: 1PX solid rgba(246,246,246,1);
    align-items: center;
    justify-content: space-between;
    .icon {
      border-radius: 50%;
      background: #B2B4B6;
      height: 63px;
      width: 63px;
      margin: 0 31px;
      line-height: 63px;
      text-align: center;
      color: white;
      font-size:26px;
    }
    .detail {
      flex-grow: 1;
      .detail-title {
        display: flex;
        align-items: center;
        font-size:26px;
      }
      .detail-title div:first-child{
        font-weight: bold;
        color: #333;
        margin-right: 25px;
      }
      .detail-title div:nth-child(2){
        font-size:24px;
        color:rgba(153,153,153,1);
        margin-right: 25px;
      }
      .detail-title div:nth-child(3) {
        width: 54px;
        height: 27px;
        background: #FAC4D2;
        font-size:18px;
        color:rgba(236,84,122,1);
        text-align: center;
        line-height: 27px;
        border-radius:5px;
      }
    }
    .detail > div:nth-child(2) {
      font-size:22px;
      font-weight:400;
      color:rgba(51,51,51,1);
      line-height:40px;
    }
    .detail > div:nth-child(3) {
      font-size:22px;
      font-weight:400;
      color:rgba(51,51,51,1);
      line-height:40px;
    }
    .operation {
      height: 71px;
      padding: 0 25px;
      font-size: 24px;
      line-height: 71px;
      text-align: center;
      color: #999;
      border-left: 1PX solid #D9D9D9;
    }
  }
</style>
